import { useMemo } from 'react';
import { useGetReportsQuery } from '../store/api-slice';
import { useConfig } from '../eliot-components/src/ConfigProvider/hooks';
import { useAuthUser } from '../contexts/AuthProvider/hooks';

export const useSharedReports = () => {
  const config = useConfig();
  const { authUser } = useAuthUser();

  const queryParams = useMemo(
    () => ({
      apiBaseURL: config.apiBaseURL,
      orgs: authUser?.selectedOrgs || [],
      filters: [
        {
          category: 'archived',
          value: 'true',
        },
      ],
    }),
    [config.apiBaseURL, authUser?.selectedOrgs]
  );
  const shouldFetch = authUser?.selectedOrgs?.length > 0;

  const { data: reports = [] } = useGetReportsQuery(queryParams, {
    skip: !shouldFetch,
  });

  return reports;
};
